/**
 * Interface languages. Kept identical to the `i18n` block of next.config.ts:
 * Spanish (Mexico) is the default, English lives under /en.
 */
export const locales = ['es-mx', 'en']

export const defaultLocale = 'es-mx'

export type Locale = 'es-mx' | 'en'

export const toLocale = (value: string | undefined | null): Locale => (value === 'en' ? 'en' : 'es-mx')

/** BCP 47 tag used by Intl formatters and the html lang attribute. */
export const intlTag = (locale: Locale): string => (locale === 'en' ? 'en-US' : 'es-MX')
